export default "__VITE_ASSET__BnfYB$7Y__";